import { useState } from 'react';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@bwoty-web/ui-kit';
import PropTypes from 'prop-types';
import ContentWrapper from './contentWrapper';
import './accommodationConceptContent.scss';
import { updateUrlWithOpenHotelSection } from '../../../../../utils/url';

const AccommodationConceptContent = ({
  conceptContent,
  labels,
  toggleRoomInfo,
  selectedSubSection,
}) => {
  const [selectedTab, setSelectedTab] = useState(selectedSubSection);

  if (!conceptContent) {
    return null;
  }

  const tabs = conceptContent.map((fs) => fs.heading || '');

  if (tabs?.length < 2) {
    return (
      <ContentWrapper
        texts={labels}
        selected
        content={conceptContent[0]}
        toggleRoomInfo={toggleRoomInfo}
      />
    );
  }

  return (
    <Tabs
      onChange={(i) => {
        setSelectedTab(i);
        updateUrlWithOpenHotelSection(`accommodation:${i}`);
      }}
      selectedIndex={selectedTab}
      defaultIndex={selectedTab}
    >
      <TabList>
        {tabs.map((tab) => {
          return <Tab key={tab}>{tab}</Tab>;
        })}
      </TabList>
      <TabPanels>
        {conceptContent.map((content, i) => (
          <TabPanel key={content.heading}>
            <ContentWrapper
              texts={labels}
              selected={i === selectedTab}
              index={i}
              content={content}
              toggleRoomInfo={toggleRoomInfo}
              tabsExist={tabs.length > 1}
            />
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
};

AccommodationConceptContent.propTypes = {
  conceptContent: PropTypes.arrayOf(PropTypes.shape({})),
  labels: PropTypes.shape({}),
  toggleRoomInfo: PropTypes.func.isRequired,
  selectedSubSection: PropTypes.number,
};

AccommodationConceptContent.defaultProps = {
  conceptContent: [],
  labels: null,
  selectedSubSection: 0,
};

export default AccommodationConceptContent;
